import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[mdTooltip]',
})
export class TooltipDirective implements OnChanges, OnDestroy {
  @Input() mdTooltip: string | null | undefined = null;

  constructor(private elementRef: ElementRef) {}

  ngOnChanges(changes: SimpleChanges) {
    try {
      $(this.elementRef.nativeElement).tooltip('dispose');
      if (this.mdTooltip) {
        $(this.elementRef.nativeElement).tooltip({
          html: true,
          title: this.mdTooltip,
          // https://stackoverflow.com/questions/47623420/how-to-enable-bootstrap4-tooltips-inside-an-angular-app
          sanitize: false,
          sanitizeFn: content => content,
        });
      }
    } catch {
      // Bootstrap jQuery tooltip plugin not loaded — no-op so render doesn't break.
    }
  }

  ngOnDestroy(): void {
    try {
      $(this.elementRef.nativeElement).tooltip('dispose');
    } catch {
      // Bootstrap jQuery tooltip plugin not loaded — no-op so navigation doesn't break.
    }
  }
}
